import React from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import packageJson from '../../../package.json';
import {UserButton} from "@clerk/clerk-react";
import {paths} from "@/constants/paths.js";
import constants from "@/constants/constants.js";
import WorkflowsSwitch from "@/components/WorkflowsSwitch.js";
import UserSwitcher from "@/components/UserSwitcher.js";
import {useKayAuth} from "@/context/AuthContext.js";
import {Button, Tooltip} from "@/components/ui/index.js";
import {TooltipContent, TooltipTrigger} from "@/components/ui/tooltip.js";
import {FileClock, House, Settings} from "lucide-react";

const iconProps = { size: 20 }
const siderButtons = [
  {icon: <House {...iconProps} />, label: 'Home', path: paths.HOME},
  {icon: <Settings {...iconProps} />, label: 'Settings', path: paths.SETTINGS},
  {icon: <FileClock {...iconProps} />, label: 'History', path: paths.HISTORY},
];

const HomeSider = () => {
  const location = useLocation();
  const nav = useNavigate();
  const {ownUserId} = useKayAuth();

  const usePathSegment = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    return pathSegments[0] ?? paths.HOME;
  };

  const openPage = (path: string) => {
    const urlPath = [path].join('/').replace('//', '/');
    nav(urlPath, {replace: true});
  };

  const currentPath = usePathSegment() || '';

  return (
    <nav className="flex w-48 md:w-56 flex-col justify-between bg-slate shadow-lg">
      <div>
        <div className="mt-16 pb-8">
          <div className="flex items-center justify-center">
            <Link to={'/'}>
              <img
                alt="logo"
                className="w-20"
                src={'/full-logo.png'}
              />
            </Link>
          </div>
        </div>
        <ul className="flex flex-col gap-3 p-4">
          {siderButtons.map(({icon, label, path}) => (
            <li
              className={`
            flex items-center gap-2 w-full p-2 rounded-lg cursor-pointer
            transition-all duration-200 hover:bg-kay-slate/80 hover:shadow-none
            ${currentPath === path ? 'bg-kay-slate text-slate-900 shadow-sm' : 'text-slate-600'}
          `}
              key={label}
              onClick={() => openPage(path)}
            >
              <span className="text-current text-xs">
                {icon}
              </span>
              <span className="font-medium">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <footer className="px-3 pt-9 pb-5 flex flex-col items-center space-y-4 text-center text-xs">

        {
          ownUserId && <UserSwitcher/>
        }

        <WorkflowsSwitch/>

        <UserButton showName/>

        <span
          className='text-gray-400 cursor-pointer hover:underline'
          onClick={() => {
            window.open(constants.changelogLink, '_blank')
          }}
        >
          <span className="text-gray-600">v{packageJson.version}</span>
        </span>

      </footer>
    </nav>
  );
};

export default HomeSider;
